import React from 'react';
import { useFormik } from 'formik';
import { Alert, AlertTitle } from '@mui/material';

export default function Manage2faAuthenticatorStep3(props) {
    const dialogSubmit = React.useRef(props.dialogSubmit);
    const recoveryCodes = React.useState(props.recoveryCodes);

    const formik = useFormik({
        initialValues: {},
        onSubmit: async (values) => {
            props.onValidate(recoveryCodes);
        },
    });

    React.useEffect(() => {
        if (props.dialogSubmit !== dialogSubmit.current) {
            dialogSubmit.current = props.dialogSubmit;
            formik.handleSubmit();
        }
    });

    return (
        <>
            <Alert sx={{ mt: 2, mb: 2 }} severity="warning">
                <AlertTitle>Put these codes in a safe place.</AlertTitle>
                If you lose your device and don't have the recovery codes you will lose access to your account.
                <br /><br />
                { recoveryCodes[0]?.map(code => (
                    <div style={{color: "red"}}>
                        <code>{code}</code>
                        <br />
                    </div>
                ))}
            </Alert>
        </>
    );
}